import React from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { useParams, Redirect } from 'react-router-dom'
import { Card, Flex, Heading1, IconButton, LinkButton, Switch, Text } from 'adl'
import numeral from 'numeral'

import ListItem from 'components/ListItem'
import StandardLayout from 'components/layouts/Standard'
import MockCard from 'components/MockCard'
import LabelValue from 'components/LabelValue'

const FrozenLine = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: ${props => props.theme.colors.danger};
`

const FrozenText = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: ${props => props.theme.colors.danger};
`

const ListItemLR = ({ children, ...rest }) => (
  <ListItem {...rest}>
    <Flex justify="space-between">{children}</Flex>
  </ListItem>
)

export default ({ history }) => {
  const { id } = useParams()
  const account = useSelector(state => state.cards.cards.find(c => c.id === id))
  if (!account) {
    return <Redirect to="/cards" />
  }

  const type = account.type

  const dispatch = useDispatch()

  return (
    <StandardLayout>
      <Heading1>
        <IconButton onClick={() => history.goBack()} style={{ marginRight: 8 }}>
          <i className="icon-chevron-left" />
        </IconButton>{' '}
        Card Options
      </Heading1>

      <div style={{ maxWidth: 768 }}>
        <Card elevation={2}>
          {account.frozen && <FrozenLine />}
          <Card.Body style={{ padding: 32 }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div style={{ marginRight: 32 }}>
                <MockCard provider={account.provider} size={96}>
                  ••••{account.mask}
                </MockCard>
              </div>
              <div>
                <Text>
                  <strong>{account.nickname}</strong>
                </Text>
                {account.frozen && <FrozenText>Frozen</FrozenText>}
                {type === 'credit' && (
                  <>
                    <LabelValue
                      id={'current-balance-value'}
                      label={'Current Balance'}
                      value={numeral(account.balance).format('$0,0.00')}
                    />
                    <LabelValue
                      id={'credit-limit-value'}
                      label={'Credit Limit'}
                      value={numeral(account.creditLimit).format('$0,0.00')}
                    />
                  </>
                )}
              </div>
            </div>
          </Card.Body>
        </Card>
        <Card elevation={2}>
          <ListItemLR>
            <div>Nickname</div>
            <div>
              {account.nickname}{' '}
              <IconButton size={16}>
                <i className="icon-pencil" />
              </IconButton>
            </div>
          </ListItemLR>
          <ListItemLR>
            <div>Freeze Card</div>
            <div>
              <Switch
                checked={account.frozen}
                onChange={() =>
                  dispatch({
                    type: 'MODIFY_CARD',
                    payload: {
                      id,
                      data: {
                        frozen: !account.frozen
                      }
                    }
                  })
                }
              />
            </div>
          </ListItemLR>
          <ListItemLR>
            <div>Manage Pin</div>
            <div>
              <i className="icon-chevron-right" />
            </div>
          </ListItemLR>
          <ListItemLR style={{ paddingLeft: '2rem', paddingRight: '2rem' }}>
            <LinkButton>Request Replacement Card</LinkButton>
            <LinkButton color="danger">Cancel Card</LinkButton>
          </ListItemLR>
        </Card>
      </div>
    </StandardLayout>
  )
}
